import { create } from 'zustand';
import { authAPI } from '../services/api';

export const useAuthStore = create((set) => ({
  user: null,
  accessToken: localStorage.getItem('accessToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  isAuthenticated: !!localStorage.getItem('accessToken'),
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      console.log('🔐 Login attempt:', email);
      const response = await authAPI.login(email, password);
      console.log('✅ Login response:', response.data);
      const { user, accessToken, refreshToken } = response.data.data;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      console.log('💾 Tokens saved to localStorage');

      set({
        user,
        accessToken,
        refreshToken,
        isAuthenticated: true,
        isLoading: false,
      });

      console.log('🎯 Auth state updated, isAuthenticated: true');
      return true;
    } catch (error) {
      console.error('❌ Login error:', error);
      const message = error.response?.data?.message || 'Login failed';
      console.error('Error message:', message);
      set({ error: message, isLoading: false });
      return false;
    }
  },

  logout: async () => {
    // Clear local session state before the network call (not after) so a
    // slow /auth/logout response can't resolve later and clobber a session
    // established by a subsequent login that happened in the meantime.
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
    });

    try {
      await authAPI.logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  fetchUser: async () => {
    try {
      const response = await authAPI.me();
      set({ user: response.data.data });
      return response.data.data;
    } catch (error) {
      set({ isAuthenticated: false, user: null });
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      throw error;
    }
  },
}));
